<template>
  <span class="vip-badge" role="status" aria-label="Alpha Whale" title="Alpha Whale">
    <i class="fa-solid fa-gem" aria-hidden="true"></i>
  </span>
</template>

<style scoped lang="scss">
.vip-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: $accent-yellow;
}

.vip-badge i {
  font-size: 1.3rem;
  line-height: 1;
}
</style>
